"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUsersViewModel = exports.SORT_OPTIONS = exports.ROLE_VALUES = exports.ROLE_LABEL_BY_NAME = void 0;
var demo_auth_context_1 = require("../../shared/auth/demo-auth-context");
var ai_hub_rbac_api_service_1 = require("../../shared/services/ai-hub-rbac-api.service");
var react_1 = require("react");
exports.ROLE_LABEL_BY_NAME = {
    admin: 'Administrator',
    owner: 'Owner',
    'group-owner': 'Group owner',
    reviewer: 'Reviewer',
    'regular-user': 'Regular user',
};
exports.ROLE_VALUES = [
    'admin',
    'owner',
    'group-owner',
    'reviewer',
    'regular-user',
];
exports.SORT_OPTIONS = [
    { key: 'displayName', label: 'Name' },
    { key: 'role', label: 'Role' },
    { key: 'email', label: 'Email' },
];
var normalizeRole = function (roleName) {
    var normalized = (roleName || '').trim().toLowerCase();
    if (normalized === 'admin' ||
        normalized === 'owner' ||
        normalized === 'group-owner' ||
        normalized === 'reviewer') {
        return normalized;
    }
    return 'regular-user';
};
var mapApiUserToRow = function (user) {
    var _a;
    var id = (user.objectId || '').trim();
    if (!id) {
        return null;
    }
    var email = (user.email || '').trim();
    var displayName = (user.displayName || '').trim() || email || id;
    return {
        id: id,
        displayName: displayName,
        email: email,
        role: normalizeRole((_a = user.role) === null || _a === void 0 ? void 0 : _a.name),
    };
};
var compareText = function (left, right) {
    return left.localeCompare(right, undefined, { sensitivity: 'base' });
};
exports.useUsersViewModel = function () {
    var activeUser = demo_auth_context_1.useDemoAuth().activeUser;
    var isAdmin = activeUser.role === 'admin';
    var _a = react_1.useState(activeUser.id), currentUserObjectId = _a[0], setCurrentUserObjectId = _a[1];
    var _b = react_1.useState([]), rows = _b[0], setRows = _b[1];
    var _c = react_1.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = react_1.useState(''), error = _d[0], setError = _d[1];
    var _e = react_1.useState('displayName'), sortKey = _e[0], setSortKey = _e[1];
    var _f = react_1.useState('asc'), sortDirection = _f[0], setSortDirection = _f[1];
    var _g = react_1.useState({}), draftRoleByUserId = _g[0], setDraftRoleByUserId = _g[1];
    var _h = react_1.useState('owner'), requestedRole = _h[0], setRequestedRole = _h[1];
    var _j = react_1.useState(null), feedback = _j[0], setFeedback = _j[1];
    react_1.useEffect(function () {
        var cancelled = false;
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, users, currentUser_1, mapped, currentUser, mappedCurrentUser, loadError_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsLoading(true);
                        setError('');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        if (!isAdmin) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all([ai_hub_rbac_api_service_1.fetchUsers(), ai_hub_rbac_api_service_1.fetchCurrentUser()])];
                    case 2:
                        _a = _b.sent(), users = _a[0], currentUser_1 = _a[1];
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        setCurrentUserObjectId((currentUser_1 === null || currentUser_1 === void 0 ? void 0 : currentUser_1.objectId) || activeUser.id);
                        mapped = users
                            .filter(function (user) { return user.isActive !== false; })
                            .map(mapApiUserToRow)
                            .filter(function (row) { return row !== null; });
                        setRows(mapped);
                        return [2 /*return*/];
                    case 3: return [4 /*yield*/, ai_hub_rbac_api_service_1.fetchCurrentUser()];
                    case 4:
                        currentUser = _b.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        if (currentUser) {
                            setCurrentUserObjectId(currentUser.objectId);
                            mappedCurrentUser = mapApiUserToRow(currentUser);
                            setRows(mappedCurrentUser ? [mappedCurrentUser] : []);
                            return [2 /*return*/];
                        }
                        setCurrentUserObjectId(activeUser.id);
                        setRows([
                            {
                                id: activeUser.id,
                                displayName: activeUser.displayName,
                                email: '',
                                role: activeUser.role,
                            },
                        ]);
                        return [3 /*break*/, 7];
                    case 5:
                        loadError_1 = _b.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        setError(loadError_1 instanceof Error ? loadError_1.message : 'Could not load users.');
                        return [3 /*break*/, 7];
                    case 6:
                        if (!cancelled) {
                            setIsLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        void run();
        return function () {
            cancelled = true;
        };
    }, [activeUser.displayName, activeUser.id, activeUser.role, isAdmin]);
    var sortedRows = react_1.useMemo(function () {
        var nextRows = __spreadArrays(rows);
        nextRows.sort(function (left, right) {
            var leftRole = exports.ROLE_LABEL_BY_NAME[left.role];
            var rightRole = exports.ROLE_LABEL_BY_NAME[right.role];
            var byKey = {
                displayName: compareText(left.displayName, right.displayName),
                role: compareText(leftRole, rightRole),
                email: compareText(left.email, right.email),
            };
            var result = byKey[sortKey];
            return sortDirection === 'asc' ? result : -result;
        });
        return nextRows;
    }, [rows, sortDirection, sortKey]);
    var handleSort = function (targetSortKey) {
        if (sortKey === targetSortKey) {
            setSortDirection(function (current) { return (current === 'asc' ? 'desc' : 'asc'); });
            return;
        }
        setSortKey(targetSortKey);
        setSortDirection('asc');
    };
    var handleSelectRole = function (userId, role) {
        setDraftRoleByUserId(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[userId] = role, _a)));
        });
    };
    var handleApplyRole = function (userId) {
        if (userId === currentUserObjectId) {
            setFeedback({
                kind: 'info',
                text: 'You cannot change your own role.',
            });
            return;
        }
        var selectedRole = draftRoleByUserId[userId];
        if (!selectedRole) {
            return;
        }
        setError('');
        void (function () { return __awaiter(void 0, void 0, void 0, function () {
            var updatedUser, nextRole_1, applyError_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ai_hub_rbac_api_service_1.updateUserRole(userId, selectedRole)];
                    case 1:
                        updatedUser = _b.sent();
                        nextRole_1 = updatedUser ? normalizeRole((_a = updatedUser.role) === null || _a === void 0 ? void 0 : _a.name) : selectedRole;
                        setRows(function (currentRows) {
                            return currentRows.map(function (row) { return (row.id === userId ? __assign(__assign({}, row), { role: nextRole_1 }) : row); });
                        });
                        setDraftRoleByUserId(function (currentDrafts) {
                            var _a = currentDrafts, _b = userId, _removed = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                            return rest;
                        });
                        setFeedback({
                            kind: 'success',
                            text: 'Role updated successfully.',
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        applyError_1 = _b.sent();
                        setError(applyError_1 instanceof Error ? applyError_1.message : 'Could not update user role.');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    };
    var handleRequestRole = function () {
        setFeedback({
            kind: 'info',
            text: "Role request for " + exports.ROLE_LABEL_BY_NAME[requestedRole] + " queued in UI. Backend request endpoint will be wired when contract is ready.",
        });
    };
    return {
        isAdmin: isAdmin,
        currentUserObjectId: currentUserObjectId,
        isLoading: isLoading,
        error: error,
        feedback: feedback,
        sortedRows: sortedRows,
        sortKey: sortKey,
        sortDirection: sortDirection,
        requestedRole: requestedRole,
        draftRoleByUserId: draftRoleByUserId,
        handleSort: handleSort,
        handleSelectRole: handleSelectRole,
        handleApplyRole: handleApplyRole,
        handleSetRequestedRole: setRequestedRole,
        handleRequestRole: handleRequestRole,
    };
};
